import React from 'react'
import PageTitle from './PageTitle';

const ResetPassword = () => (
	<PageTitle title='Reset Password' />
);

export default ResetPassword